import { DefaultPalette } from 'office-ui-fabric-react';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routes } from '../../../common/routes';
import MessageCourier from '../../../lib/MessageCourier';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../../styles/button-styles';
import SystemClient from '../../../system/SystemClient';
import ViewWrapperWithCommandBar from '../../Common/Layout/ViewWrapperWithCommandBar';
import PlanillaPartidoForm from '../../PlanillaPartido/PlanillaPartidoForm';
import PlanillaDigitalView from '../PlanillaDigitalView';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import PlanillaDigitalForm from '../PlanillaDigitalForm';
import { useTranslation } from 'react-i18next';
import DialogTemplate from '../../Common/DialogTemplate';
import {
  DefaultButton,
  Dropdown,
  IComboBoxOption,
  IDropdownOption,
  Icon,
  Label,
  Text,
  TextField,
  ColorPicker,
  IColor,
  Toggle,
} from '@fluentui/react';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import TextArea from '../../../lib/FormValidator/Form/TextAreaField';
import { EventoXPlanilla } from '../../../system/EventoXPlanilla/EventoXPlanilla';
import { TimeoutXPlanilla } from '../../../system/TimeoutXPlanilla/TimeoutXPlanilla';
import { SUSPENDIDO, FINALIZADO } from '../PlanillaDigitalViewController';

interface ISeleccionarColorDialog {
  showInitialDialog: boolean;
  setShowInitialDialog: (v: boolean) => void;
  localColor: string;
updateColor: (ev: any, colorObj: IColor) => void
visitanteColor: string;
updateVisColor: (ev: any, colorObj: IColor) => void
}

const SeleccionarColorDialog = ({
  showInitialDialog,
setShowInitialDialog,
localColor,
updateColor,
visitanteColor,
updateVisColor
}: ISeleccionarColorDialog) => {
  return (
    <DialogTemplate
      showDialog={showInitialDialog}
      toggleShowDialog={() => setShowInitialDialog(false)}
      title={'Configuración inicial'}
      onAccept={() => setShowInitialDialog(false)}
      onCancel={() => setShowInitialDialog(false)}
      acceptText={'Listo'}
      cancelText={''}
      hideCancelButton
      minWidth={800}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm6">
            <Label>Selecciona el color del equipo local</Label>
            <Text style={{ display: 'block', fontWeight: 400, fontSize: 10 }}>
              <Icon
                iconName="Info"
                style={{ position: 'relative', top: '0px', marginRight: 2, fontSize: 8 }}
              ></Icon>
              Esto es solo para que puedas usar de referencia para identificar los equipos en el momento en
              que empiece el partido
            </Text>

            <ColorPicker
              className="cp-for-planilla"
              color={localColor}
              onChange={updateColor}
              alphaType={'none'}
              showPreview={false}
              styles={{
                panel: { padding: 0 },
              }}
            />
            <div className="ms-Grid-col ms-lg3  mt-2"></div>
            <div className="ms-Grid-col ms-lg4  mt-2">
              <div className="text-center">
                <div className={'dorsal-planilla-example'} style={{ top: '82% !important' }}>
                  5
                </div>
                <Icon style={{ fontSize: '6vw', color: localColor }} iconName="Shirt"></Icon>
              </div>
            </div>
            <div className="ms-Grid-col ms-lg4  mt-2"></div>
          </div>
          <div className="ms-Grid-col ms-sm6">
            <Label>Selecciona el color del equipo visitante</Label>
            <Text style={{ display: 'block', fontWeight: 400, fontSize: 10 }}>
              <Icon
                iconName="Info"
                style={{ position: 'relative', top: '0px', marginRight: 2, fontSize: 8 }}
              ></Icon>
              Esto es solo para que puedas usar de referencia para identificar los equipos en el momento en
              que empiece el partido
            </Text>

            <ColorPicker
              className="cp-for-planilla"
              color={visitanteColor}
              onChange={updateVisColor}
              alphaType={'none'}
              showPreview={false}
              styles={{
                panel: { padding: 0 },
              }}
            />
            <div className="ms-Grid-col ms-lg3  mt-2"></div>
            <div className="ms-Grid-col ms-lg4  mt-2">
              <div className="text-center">
                <div className={'dorsal-planilla-example'}>5</div>
                <Icon style={{ fontSize: '6vw', color: visitanteColor }} iconName="Shirt"></Icon>
              </div>
            </div>
            <div className="ms-Grid-col ms-lg4  mt-2"></div>
          </div>
        </div>
      </div>
    </DialogTemplate>
  );
};

export default SeleccionarColorDialog;
